import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/additionalOptions', request)
}

export {get}
